import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, PlatformLocation } from '@angular/common';

import { AuthService } from 'services/auth.service';
import { GlobalService } from 'services/global.service';
import { AnswerService } from 'student/answer/answer.service';
import { PreviewService } from 'aplication/preview/preview.service';
import { PagerService } from 'services/index'

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  breadcrumbs: any[];

  nextQuestion: Boolean;
  isAnswerCorrect: Boolean;
  processing: boolean;
  isNextAvailable: boolean = false;
  nextQuestionId;
  courseCode; // if role == 'admin' this var value is courseFormatId else courseCode;
  questionId;
  imageUrl: any = "";
  feedbackText;
  feedbackText_under;
  isFeedbackDraft: Boolean = false;
  answer;
  questionData;
  questionPosition;
  questionTotal;
  RealNextQuestionId=-1;
  nextButtonQid=-1;

  prev_question_id;
  
  questionHelpers = new this.globalService.enumHelpers.QuestionType();

  constructor(
    private authService: AuthService,
    private router: Router,
    private pagerService: PagerService,
    private formBuilder : FormBuilder,
    private route: ActivatedRoute,
    private location: Location,
    private answerService: AnswerService,
    private previewService: PreviewService,
    private globalService: GlobalService,
    private plocation: PlatformLocation,
  ) {
    this.nextQuestion = false;
    this.isAnswerCorrect = true;
    this.getRoute();
    this.makingbreadcrumbs();
    if (this.authService.role == 'student') {
      this.processing = true;
      this._getStudentFeedback();
    } else if (this.authService.role == 'admin') {
      this.processing = true;
      this._getAdminFeedback();
    } else if (this.authService.role == 'courseformat_editor') {
      this.processing = true;
      this._getAdminFeedback();
    }
  }

  ngOnInit() {
    // this code used for disabled browser back button;
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };

  }

  getRoute() {
    this.courseCode = this.route.snapshot.paramMap.get('course_code');
    if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') this.courseCode = this.route.snapshot.paramMap.get('course_format_id');
    this.questionId = this.route.snapshot.paramMap.get('question_id');

    this.answer = JSON.parse(localStorage.getItem('preview_answer'));
  }

  _getStudentFeedback() {
    this.answerService.getAnswer(this.authService.user.id, this.courseCode, this.questionId)
    .then(res => {
      console.log(res);
      if(res.question.type == this.questionHelpers.getValue('hide')){
        console.log('hide');
        this.prevPage();
      }else{
        if(res.next_qid){
          this.RealNextQuestionId=res.next_qid;
          //console.log(res.next_qid);
        }
        if(res.next_button_qid){
          this.nextButtonQid = res.next_button_qid;
        }
        this.questionData = res.question;
        this.questionPosition = res.question_position;
        this.questionTotal = res.question_total;
        this.feedbackText = this.globalService.getFooterPattern(res);
        this.feedbackText_under = this.globalService.getFooterPattern_under(res);

        // used for feedback.component.html title
        if (!res.answer.result) this.isAnswerCorrect = res.answer.result;

        // used for feedback.component.html btn name & feedback.component.ts confirm() 
        if (res.next_question_id) {
          this.isNextAvailable = true;
          this.nextQuestionId = res.next_question_id;
        }

        // used for feedback.component.ts draftFeedback()
        if (res.answer.feedback) this.isFeedbackDraft = res.answer.feedback;

        if(res.answer.choice){

          if (res.answer.choice==1 && res.question.feedback_image) {
            this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image);
          }else if (res.answer.choice==2 && res.question.feedback_image2) {
            this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image2);
          }else if (res.answer.choice==3 && res.question.feedback_image3) {
            this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image3);
          }else if (res.answer.choice==4 && res.question.feedback_image4) {
            this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image4);
          }
          
        }else{
          if (res.question.feedback_image) {
            this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image);
          }else{
            this.imageUrl ='';
          }
        }

        //表示するものが何もなかったらページをスキップして次の問題へいく仕様を追加
        if(this.checkFeedBackPageSkip()){
          this.skipThisPage();
        }

        this.processing = false;
      }
    })
    .catch(err => {
      console.log(err);
      this.router.navigateByUrl('/student/dashboard');
    });
  }

  _getAdminFeedback() {
    this.previewService.getFeedback(this.questionId, this.answer.answer)
    .then(res => {
      
      this.imageUrl='';

      this.questionData = res.question;
      if(!this.questionPosition){
        this.questionPosition = res.question_position;
      }
      if(!this.questionTotal){
        this.questionTotal = res.group_questions;
      }

      if(this.answer.answer && res.question.type == this.questionHelpers.getValue('selection')){
        res['choice']=parseInt( this.answer.answer );
        res['answer']={};//parseInt( this.answer.answer );
        res['answer']['choice']=parseInt( this.answer.answer );
      }
      this.feedbackText = this.globalService.getFooterPattern(res);
      this.feedbackText_under = this.globalService.getFooterPattern_under(res);

      // used for feedback.component.html title
      if (res.question.type == this.questionHelpers.getValue('selection')) {
        if (res.question.right_choice != this.answer.answer) this.isAnswerCorrect = false;
      }

      // used for feedback.component.html btn name & feedback.component.ts confirm()
      if (res.next_question_id) {
        this.isNextAvailable = true;
        this.nextQuestionId = res.next_question_id;
      }else{
        this.isNextAvailable = false;
        this.nextQuestionId = 0;
      }

      if(res.answer && res.answer.choice){
        
        if (res.answer.choice==1 && res.question.feedback_image) {
          this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image);
        }else if (res.answer.choice==2 && res.question.feedback_image2) {
          this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image2);
        }else if (res.answer.choice==3 && res.question.feedback_image3) {
          this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image3);
        }else if (res.answer.choice==4 && res.question.feedback_image4) {
          this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image4);
        }
        
      }else{
        if (res.question.feedback_image) {
          this.imageUrl = this.globalService.getImageUrl(res.question.feedback_image);
        }else{
          this.imageUrl = '';
        }
      }

      //表示するものが何もなかったらページをスキップして次の問題へいく仕様を追加
      if(this.checkFeedBackPageSkip()){
        this.skipThisPage();
      }

      this.processing = false;
    })
    .catch(err => console.log(err));

    //追加情報取得
    this.previewService.getAnswer(this.questionId,this.courseCode)
    .then(res => {
      this.questionPosition = res.question_position;
      this.questionTotal = res.question_total;
    });
  }

  _onErrorImg() {
    this.imageUrl = "";
  }

  makingbreadcrumbs() {
    this.breadcrumbs = [
      {
        title : "ダッシュボード",
        link : "/" + this.authService.role + '/dasboard'
      },
      {
        title : "問題",
        link : "" 
      },
      {
        title : "解説・フィードバック",
        link : ""
      },
    ];

    if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
      this.breadcrumbs.splice(1, 0, {
        title: 'コース・プレビュー',
        link: '/' + this.authService.role + "/preview/"+this.courseCode
      });
      this.breadcrumbs[2].link = "/" + this.authService.role + "/preview/"+this.courseCode+'/answer/'+this.questionId;
    }
  }

  draftFeedback() {
    const body = {
      feedback : true
    }

    this.answerService.updateFeedback(body, this.questionId, this.courseCode)
    .then(resSucc => {
      const url = "/" + this.authService.role + "/dashboard";

      this.router.navigateByUrl(url);
    })
    .catch(err => {
      console.log(err);
    });
  }

  confirm() {
    if (this.isFeedbackDraft) {
      const body = {
        feedback : false
      }

      this.answerService.updateFeedback(body, this.questionId, this.courseCode)
      .then(response => console.log(response))
      .catch(err => console.log(err));
    }

    let url = "/" + this.authService.role + "/dashboard";

    if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
      url = "/" + this.authService.role + "/preview/" + this.courseCode;
    }

    if (this.isNextAvailable) {
      url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.nextQuestionId;

      if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
        url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.nextQuestionId;
      }
    }

    this.router.navigateByUrl(url);
  }

  //１つ前に戻る
  prevPage(){
    let url = "/" + this.authService.role + "/dashboard";

    if (this.questionId) {
      url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.questionId;

      if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
        url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.questionId;
      }
    }

    this.router.navigateByUrl(url);
  }

  //1つ進む（回答済みの場合のボタン）
  nextPage(){
    let url = "/" + this.authService.role + "/dashboard";

    if (this.RealNextQuestionId) {
      url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.RealNextQuestionId;

      if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
        url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.RealNextQuestionId;
      }
    }


    this.router.navigateByUrl(url);
  }

  //1つ進む（回答にかかわらず次の問題へボタン）
  goToNext(){
    let url = "/" + this.authService.role + "/dashboard";

    if (this.nextButtonQid) {
      url = "/" + this.authService.role + "/answer/" + this.courseCode + "/" + this.nextButtonQid;
      
      //adminは戻らないので進まないが一応
      if (this.authService.role == 'admin' || this.authService.role == 'courseformat_editor') {
        url = "/" + this.authService.role + "/preview/" + this.courseCode + "/answer/" + this.nextButtonQid;
      }
      
    }


    this.router.navigateByUrl(url);
  }

  progressTagValue(questionPosition,questionTotal){
    var perVal=((questionPosition)/questionTotal);
    if(perVal<=0){
      perVal=0.05;
    }
    perVal = perVal*100;
    return Math.floor(perVal)+'%';
  }



  //テキストが空かチェックする
  checkTextEmpty(text_data){
    if(text_data==''){
      return true;
    }else if(!text_data){
      return true;
    }else if(text_data==null){
      return true;
    }else if(text_data==undefined){
      return true;
    }else if(text_data=='undefined'){
      return true;
    }else{
      return false;
    }
  }
  //どういう状況をスキップ対象とするか[M56]
  checkFeedBackPageSkip(){
    //どれか１つでも空でないならスキップしない
    if(!this.checkTextEmpty(this.feedbackText)){
      return false;
    }else if(!this.checkTextEmpty(this.feedbackText_under)){
      return false;
    }else if(!this.checkTextEmpty(this.questionData.feedback_header)){
      return false;
    }else if(!this.checkTextEmpty(this.questionData.feedback_footer)){
      return false;
    }else if(!this.checkTextEmpty(this.imageUrl)){
      return false;
    }else{
      //スキップする
      return true;
    }
  }
  skipThisPage(){
    console.log('sikipThisPage()');
    //戻るで戻ってきてた場合
    if(this.route.snapshot.fragment=='prevback'){
      console.log('prevPage()');
      this.prevPage();
    }else{
      //次のページへ強制移動
      if(!(this.RealNextQuestionId!=-1 && this.RealNextQuestionId!=this.nextQuestionId)  && this.RealNextQuestionId!=this.nextButtonQid){//回答済で次へボタンの場合
        console.log('goToNext()');
        this.goToNext();
      }else if(this.RealNextQuestionId!=-1 && this.RealNextQuestionId!=this.nextQuestionId){
        console.log('nextPage()');
        this.nextPage();
      }else{//通常進行
        console.log('confirm()');
        this.confirm();
      }
    }
  }



  ngOnDestroy() {
    // this code used for enable browser back button;
    // history.pushState({}, document.title, location.href);
    window.onpopstate = function () {
      //history.go(0);
    };
    /*
    this.plocation.onPopState=function () {
      //history.go(0);
    };
    */
  }
}



// WEBPACK FOOTER //
// ./src/app/component/shared/answer_component/feedback/feedback.component.ts